import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  errorMessage,
  hireflixInviteToInterviewRoute,
} from '@features/applications';
import { eventsInterviewKey } from '@features/events';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

type UseHireflixInviteToInterviewProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useHireflixInviteToInterview = ({
  setErrorText,
  onSuccess,
}: UseHireflixInviteToInterviewProps) => {
  const client = useQueryClient();

  const {
    mutate: hireflixInviteToInterview,
    isLoading: isHireflixInviteToInterviewLoading,
  } = useMutation({
    mutationFn: (variables: {
      company_id?: number;
      application_ids: number[];
      body: string;
    }) =>
      axiosInstance
        .post(hireflixInviteToInterviewRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(eventsInterviewKey);
        client.invalidateQueries(applicationHistoryKey);
        onSuccess?.();
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    hireflixInviteToInterview,
    isHireflixInviteToInterviewLoading,
  };
};
